import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import Dropdown from "react-bootstrap/Dropdown";
import i18n from "../../i18n";
import "./MobileLayout.css";

import {
    FaHome, FaBook, FaClock, FaCheckCircle, FaUser,
    FaFileAlt, FaCalendarAlt, FaUsers, FaUmbrellaBeach
} from 'react-icons/fa';

import Inicio from "../../assets/icons/Inicio.svg";

const MobileLayout = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = location.pathname;

    const isActive = (path) => currentPath === path;

    const navbarStyle = {
        backgroundColor: "#1A1657",
        opacity: "1",
    };

    const contentstyle = {
        textAlign: "center",
        fontFamily: "Roboto, sans-serif",
        fontSize: "0.8rem",
        color: "#EBF4F6",
    };

    const stickyNavbarStyle = {
        position: "fixed",
        bottom: 0,
        width: "100%",
        zIndex: 1050,
        height: "6rem",
    };

    return (
        <div style={{ overflowX: "hidden" }}>
            <div style={{ paddingBottom: "70px" }}>
                <Outlet />
            </div>

            <Navbar expand="lg" style={{ ...navbarStyle, ...stickyNavbarStyle }}>
                <Container className="my-0 px-0 d-flex justify-content-center">
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(5, 1fr)",
                            alignItems: "center",
                            textAlign: "center",
                            justifyItems: "center",
                            margin: "0 auto",
                            maxWidth: "700px",
                            width: "100%",
                        }}
                    >

                        <Navbar.Brand
                            className="m-0 p-0"
                            onClick={() => navigate("/dashboard")}
                            style={{
                                ...contentstyle,
                                color: isActive("/dashboard") ? "#00B2FF" : "#EBF4F6"
                            }}
                        >
                            <FaHome className="fs-2" style={{ color: isActive("/dashboard") ? "#00B2FF" : "#ffffff" }} />
                            <div className="fw-bold" style={{ marginTop: "3px" }}>{i18n.t("components.Sidebar.home")}</div>
                        </Navbar.Brand>

                        <Navbar.Brand
                            className="m-0 p-0"
                            onClick={() => navigate("/user-shifts")}
                            style={{
                                ...contentstyle,
                                color: isActive("/user-shifts") ? "#00B2FF" : "#EBF4F6"
                            }}
                        >
                            <FaBook className="fs-2" style={{ color: isActive("/user-shifts") ? "#00B2FF" : "#ffffff" }} />
                            <div className="fw-bold" style={{ marginTop: "3px" }}>{i18n.t("components.Sidebar.shift")}</div>
                        </Navbar.Brand>

                        <Navbar.Brand className="m-0 p-0">
                            <Dropdown drop="up" align="center">
                                <Dropdown.Toggle variant="transparent" id="dropdown-center" style={{ border: "none", background: "transparent", padding: 0 }}>
                                    <img src={Inicio} alt="Menu" style={{ width: "2rem", height: "2rem", cursor: "pointer" }} />
                                </Dropdown.Toggle>

                                <Dropdown.Menu
                                    className="text-center"
                                    style={{
                                        width: "300px",
                                        height: "175px",
                                        fontSize: "12px",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        backgroundColor: "#17296B",
                                    }}
                                >
                                    <div className="d-flex flex-column justify-content-center h-100">

                                        <div className="d-flex justify-content-center pt-2">
                                            <div style={{ minWidth: '100px' }}>
                                                <Dropdown.Item
                                                    onClick={() => navigate("/projects")}
                                                    style={{ backgroundColor: isActive("/projects") ? "#0E1A40" : "transparent", borderRadius: "0.5rem" }}
                                                >
                                                    <FaCheckCircle className="fs-1 text-white" />
                                                    <p className="fw-bold" style={{ marginTop: "4px", color: isActive("/projects") ? "#00B2FF" : "#ffffff" }}>
                                                        {i18n.t("components.Sidebar.projects")}
                                                    </p>
                                                </Dropdown.Item>
                                            </div>

                                            <div style={{ minWidth: '100px' }}>
                                                <Dropdown.Item
                                                    onClick={() => navigate("/profile")}
                                                    style={{ backgroundColor: isActive("/profile") ? "#0E1A40" : "transparent", borderRadius: "0.5rem" }}
                                                >
                                                    <FaUser className="fs-1 text-white" />
                                                    <p className="fw-bold" style={{ marginTop: "4px", color: isActive("/profile") ? "#00B2FF" : "#ffffff" }}>
                                                        {i18n.t("components.Sidebar.profile")}
                                                    </p>
                                                </Dropdown.Item>
                                            </div>

                                            <div style={{ minWidth: '100px' }}>
                                                <Dropdown.Item
                                                    onClick={() => navigate("/documents")}
                                                    style={{ backgroundColor: isActive("/documents") ? "#0E1A40" : "transparent", borderRadius: "0.5rem" }}
                                                >
                                                    <FaFileAlt className="fs-1 text-white" />
                                                    <p className="fw-bold" style={{ marginTop: "4px", color: isActive("/documents") ? "#00B2FF" : "#ffffff" }}>
                                                        {i18n.t("components.Sidebar.documents")}
                                                    </p>
                                                </Dropdown.Item>
                                            </div>
                                        </div>

                                        <div className="d-flex justify-content-center">
                                            <div style={{ minWidth: '100px' }}>
                                                <Dropdown.Item
                                                    onClick={() => navigate("/calendar")}
                                                    style={{ backgroundColor: isActive("/calendar") ? "#0E1A40" : "transparent", borderRadius: "0.5rem" }}
                                                >
                                                    <FaCalendarAlt className="fs-1 text-white" />
                                                    <p className="fw-bold" style={{ marginTop: "4px", color: isActive("/calendar") ? "#00B2FF" : "#ffffff" }}>
                                                        {i18n.t("components.Sidebar.calendar")}
                                                    </p>
                                                </Dropdown.Item>
                                            </div>

                                            <div style={{ minWidth: '100px' }}>
                                                <Dropdown.Item
                                                    onClick={() => navigate("/employees")}
                                                    style={{ backgroundColor: isActive("/employees") ? "#0E1A40" : "transparent", borderRadius: "0.5rem" }}
                                                >
                                                    <FaUsers className="fs-1 text-white" />
                                                    <p className="fw-bold" style={{ marginTop: "4px", color: isActive("/employees") ? "#00B2FF" : "#ffffff" }}>
                                                        {i18n.t("components.Sidebar.organization")}
                                                    </p>
                                                </Dropdown.Item>
                                            </div>
                                        </div>
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Navbar.Brand>

                        <Navbar.Brand
                            className="m-0 p-0"
                            onClick={() => navigate("/annual-leave")}
                            style={{
                                ...contentstyle,
                                color: isActive("/annual-leave") ? "#00B2FF" : "#EBF4F6"
                            }}
                        >
                            <FaClock className="fs-2" style={{ color: isActive("/annual-leave") ? "#00B2FF" : "#ffffff" }} />
                            <div className="fw-bold" style={{ marginTop: "4px" }}>{i18n.t("components.Sidebar.clock")}</div>
                        </Navbar.Brand>

                        <Navbar.Brand
                            className="m-0 p-0"
                            onClick={() => navigate("/absences")}
                            style={{
                                ...contentstyle,
                                color: isActive("/absences") ? "#00B2FF" : "#EBF4F6"
                            }}
                        >
                            <FaUmbrellaBeach
                                className="fs-2"
                                style={{
                                    color: isActive("/absences") ? "#00B2FF" : "#ffffff",
                                    cursor: "pointer"
                                }}
                            />
                            <div className="fw-bold" style={{ marginTop: "4px" }}>{i18n.t("components.Sidebar.absences")}</div>
                        </Navbar.Brand>
                    </div>
                </Container>
            </Navbar>
        </div>
    );
};

export default MobileLayout;
